'use es6';

import { isEmpty } from 'underscore';
import { getNotificationPreferences } from 'FormsUI/api/NotificationPreferences';
import { getNotificationPreferences as getNotificationPreferencesSelector } from 'FormsUI/selectors/NotificationPreferences';
const createAction = name => `@@notificationPreferences/${name}`;
export const REQUEST_NOTIFICATION_PREFERENCES = createAction('REQUEST_NOTIFICATION_PREFERENCES');
export const RECEIVE_NOTIFICATION_PREFERENCES = createAction('RECEIVE_NOTIFICATION_PREFERENCES');
export const SUCCEED_GETTING_NOTIFICATION_PREFERENCES = createAction('SUCCEED_GETTING_NOTIFICATION_PREFERENCES');
export const FAILED_GETTING_NOTIFICATION_PREFERENCES = createAction('FAILED_GETTING_NOTIFICATION_PREFERENCES');
const requestNotificationPreferences = () => ({
  type: REQUEST_NOTIFICATION_PREFERENCES
});
const receiveNotificationPreferences = receivedNotificationPreferences => ({
  type: RECEIVE_NOTIFICATION_PREFERENCES,
  preferences: receivedNotificationPreferences
});
const succeedGettingNotificationPreferences = () => ({
  type: SUCCEED_GETTING_NOTIFICATION_PREFERENCES
});
const failGettingNotificationPreferences = () => ({
  type: FAILED_GETTING_NOTIFICATION_PREFERENCES
});
export const fetchNotificationPreferences = () => (dispatch, getState) => {
  const state = getState();
  const cachedNotificationPreferences = getNotificationPreferencesSelector(state);
  if (!isEmpty(cachedNotificationPreferences)) {
    return Promise.resolve();
  }
  dispatch(requestNotificationPreferences());
  return getNotificationPreferences().then(preferences => {
    dispatch(succeedGettingNotificationPreferences());
    dispatch(receiveNotificationPreferences(preferences));
  }).catch(error => {
    dispatch(failGettingNotificationPreferences(error));
  });
};